import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowUp,
  faArrowDown,
  faSearch,
  faArrowLeft,
  faArrowRight,
  faAdd,
  faSave,
} from "@fortawesome/free-solid-svg-icons";
import "bootstrap/dist/css/bootstrap.min.css";
import "./TruckForm.css";
import { Tooltip } from "react-tooltip";
import { useNavigate } from "react-router-dom";
import GoCast from "../../Images/GoCast.png";
import axios from "axios";

const Tuck_Form = () => {
  const [isLoading, setIsLoading] = useState(false); // Loading GIF

  // Navigation To Another Page
  const navigate = useNavigate();

  // Table visibility
  const [tableVisible, setTableVisible] = useState(true);

  // Toggle table visibility
  const toggleTableVisibility = () => {
    setTableVisible(!tableVisible);
  };

  // API CODE
  const [apiData, setApiData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5); // Initial number of items per page
  const [filter, setFilter] = useState(""); // Truck ID Filter
  const [originalApiData, setOriginalApiData] = useState([]);

  //ADD
  const [showEmptyRow, setShowEmptyRow] = useState(false);
  const [modifiedData, setModifiedData] = useState([]); // New state for modified data
  const [modifiedRows, setModifiedRows] = useState(new Set()); // New state to track modified rows
  const [Key1, setKey1] = useState("");
  const [Character01, setCharacter01] = useState("");
  const [Character02, setCharacter02] = useState("");
  const [Character03, setCharacter03] = useState("");
  const [CheckBox01, setCheckBox01] = useState(false);

  const fetchData = async () => {
    setIsLoading(true); // Load GIF
    const username = "manager"; // Replace with your username
    const password = "manager"; // Replace with your password
    const apiUrl =
      "https://77.92.189.102/PPGPrecastVertical/api/v1/Ice.BO.UD102Svc/UD102s"; // Adjust the URL as needed

    try {
      const response = await fetch(apiUrl, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Basic " + btoa(username + ":" + password),
        },
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      // Check if data is an object and contains the 'value' property which is an array
      if (
        typeof data === "object" &&
        data !== null &&
        Array.isArray(data.value)
      ) {
        setApiData(data.value);
        setOriginalApiData(data.value);
        setIsLoading(false); // Loading GIF
      } else {
        console.error(
          'API response does not contain the expected array in the "value" property:',
          data
        );
      }
    } catch (error) {
      console.error("There was a problem with your fetch operation:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []); // Fetch data on component mount

  const handleFilterChange = (e) => {
    const inputValue = e.target.value;
    setFilter(inputValue);

    // If the input value is cleared, reset apiData to the original data
    if (inputValue === "") {
      setApiData(originalApiData);
    } else {
      // Filter apiData based on the input value, ensuring Key1 is defined
      const filteredData = apiData.filter(
        (item) => item.Key1 && item.Key1.includes(inputValue)
      );
      setApiData(filteredData); // Update apiData with filtered data
    }
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1); // Reset to the first page when changing items per page
  };

  const saveData = async () => {
    const username = "manager";
    const password = "manager";
    if (showEmptyRow) {
      const apiUrl = `https://77.92.189.102/PPGPrecastVertical/api/v1/Ice.BO.UD102Svc/UD102s`;
      console.log(CheckBox01);
      if (CheckBox01 === "on") {
        console.log("dakhal");
        setCheckBox01(true);
      } else {
        console.log("madakhalsh");
      }
      console.log(CheckBox01);
      const newRow = {
        Company: "EPIC06",
        Key1: Key1,
        Character01: Character01,
        Character02: Character02,
        Character03: Character03,
        CheckBox01: CheckBox01,
      };
      console.log(newRow);
      try {
        const response = await axios.post(apiUrl, newRow, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Basic " + btoa(username + ":" + password),
          },
        });
        setShowEmptyRow(false);
        console.log("Data saved successfully:", response.data);
      } catch (error) {
        console.error("Error:", error.message);
      }
    }
  };

  const renderTableRows = () => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentItems = apiData.slice(startIndex, endIndex);

    return (
      <>
        {currentItems.map((item, index) => (
          <tr key={index}>
            <td
              className="blue-hyper"
              onClick={() =>
                navigate(
                  `/truck/truckdet/${item.Key1}?Key2=${item.Key2}&Key3=${item.Key3}&Key4=${item.Key4}&Key5=${item.Key5}&Company=${item.Company}`
                )
              }
            >
              {item.Key1}
            </td>
            <td>{item.Character01}</td>
            <td>{item.Character02}</td>
            <td>{item.Character03}</td>
            <td>
              <input type="checkbox" checked={item.CheckBox01 ? "true" : ""} />
            </td>
          </tr>
        ))}
        {/* Add input fields for the empty row */}
        {showEmptyRow &&
          modifiedData.slice(startIndex, endIndex).map((item, index) => (
            <tr key={`empty-row-${index}`}>
              <td>
                <input
                  type="text"
                  placeholder="Truck ID"
                  value={Key1}
                  onChange={(e) => setKey1(e.target.value)}
                />
              </td>
              <td>
                <input
                  type="text"
                  placeholder="Description"
                  value={Character01}
                  onChange={(e) => setCharacter01(e.target.value)}
                />
              </td>
              <td>
                <input
                  type="text"
                  placeholder="Plate No."
                  value={Character02}
                  onChange={(e) => setCharacter02(e.target.value)}
                />
              </td>
              <td>
                <input
                  type="text"
                  placeholder="Resource Group"
                  value={Character03}
                  onChange={(e) => setCharacter03(e.target.value)}
                />
              </td>
              <td>
                <input
                  type="checkbox"
                  checked={CheckBox01}
                  onChange={(e) => setCheckBox01(e.target.checked)}
                />
              </td>
            </tr>
          ))}
      </>
    );
  };

  const goToNextPage = () => {
    const totalPages = Math.ceil(apiData.length / itemsPerPage);
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
    }
  };

  const renderPagination = () => {
    const totalPages = Math.ceil(apiData.length / itemsPerPage);
    const pageNumbers = [];

    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(i);
    }

    return (
      <div className="pagination-batching">
        <button onClick={goToPreviousPage} disabled={currentPage === 1} className='pre-nex'>
          Previous
        </button>
        {pageNumbers.slice(Math.max(currentPage - 2, 0), Math.min(currentPage + 1, totalPages)).map(number => (
          <button key={number} className={currentPage === number ? 'active' : ''} onClick={() => setCurrentPage(number)}>
            {number}
          </button>
        ))}
        <button onClick={goToNextPage} disabled={currentPage >= totalPages} className='pre-nex'>
          Next
        </button>
      </div>
    );
  };

  const addNewRow = () => {
    console.log("Add button clicked!");
    // Create a new row with default values or with values based on your requirements
    const newRow = {
      Key1: "",
      Character01: "",
      Character02: "",
      Character03: "",
      CheckBox01: true,
    };
    setShowEmptyRow(true);
    // Add the new row to the modifiedData state
    setModifiedData([...modifiedData, newRow]);
    // Also, update the apiData state if needed
    setApiData([...apiData, newRow]);
  };

  return (
    <div className="card rebartable">
      {isLoading && (
        <div className="loading-overlay">
          <img src={GoCast} alt="Loading..." />
        </div>
      )}
      <div className="card-header">
       
        <div className="Truck-id-container">
        <button type="button" className="toggle-table-icon" onClick={toggleTableVisibility}>
          <FontAwesomeIcon icon={tableVisible ? faArrowDown : faArrowUp} />
        </button>
          <input
            type="text"
            placeholder=" Truck ID"
            className="Search-Input"
            onChange={handleFilterChange}
          />
        </div>
        <div className="ctrl-btns-rebar">
          <button className="btn" id="add" onClick={addNewRow}>
            <FontAwesomeIcon icon={faAdd} />
          </button>
          <Tooltip anchorSelect="#add" content="Add" place="bottom" />
          <button className="btn" id="save" onClick={saveData}>
            <FontAwesomeIcon icon={faSave} />
          </button>
          <Tooltip anchorSelect="#save" content="Save" place="bottom" />
        </div>
      </div>
      {/* Conditionally render the table */}
      {tableVisible && (
        <div className="card-body">
          <div className="table-responsive">
            <div className="scrollable-table-body">
              <table className="table table-bordered">
                {/* Table content */}
                <thead className="table-primary">
                  <tr className="bg-primary text-white">
                    <th>Truck ID</th>
                    <th>Description</th>
                    <th>Plate No.</th>
                    <th>Resource Group</th>
                    <th>Sub Contract</th>
                  </tr>
                </thead>
                <tbody>{renderTableRows()}</tbody>
              </table>
            </div>
          </div>
          <div className="pagination-batching">
            <div className="items-per-page">
              <label htmlFor="itemsPerPage">Show </label>
              <select className='mx-1'
                id="itemsPerPage"
                value={itemsPerPage}
                onChange={handleItemsPerPageChange}
              >
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
              </select>
              <label htmlFor="itemsPerPage"> entries</label>
            </div>
            {renderPagination()}
          </div>
        </div>
      )}
    </div>
  );
};

export default Tuck_Form;
